module.exports = require("./sat-Olck.js");